import cookie from './cookie';
import axios from 'axios';

let auth = {
    cookieParams() {
        return {
            expires: 1,
            domain: window.location.hostname,
            path: '/'
        };
    },

    logout() {
        cookie.remove('sid');
        cookie.remove('cid');
        auth.removeToken();
    },

    setSID(key) {
        cookie.set('sid', key, auth.cookieParams());
    },

    getSID() {
        return cookie.get('sid');
    },

    setUserId(id) {
        cookie.set('cid', id, auth.cookieParams());
    },

    getUserId() {
        return cookie.get('cid');
    },

    setPostOrgReg(value) {
        cookie.set('post_org_register', value, auth.cookieParams());
    },

    removePostOrgReg() {
        cookie.remove('post_org_register', auth.cookieParams());
    },

    loggedIn() {
        return !!auth.getSID();
    },

    validatePayment(payment) {
        return axios
            .request({
                url: `/orders/authorize`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Key': auth.getSID()
                },
                data: payment
            })
            .then((resp) => resp.data);
    },
    getToken() {
        let ct = cookie.get('auth_token');
        let st = localStorage.getItem('token');

        // if the token is still stored in the cookie
        // move it to session storage.
        if (ct && !st) {
            auth.setToken(ct);
            cookie.remove('auth_token');
            st = localStorage.getItem('token');
        }
        return st;
    },

    setToken(token) {
        localStorage.setItem('token', token);
    },

    removeToken(token) {
        localStorage.removeItem('token');
    },
    getDefaultTerritory() {
        return cookie.get('dt') || 'US';
    },
    getOrgId() {
        return cookie.get('eid');
    }
};

export default auth;
